import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4396a98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "modal-footer" }


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultModal',
  props: {
  modalSize: String
},
  setup(__props) {

const props = __props;

// eslint-disable-next-line


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass({
            'modal-container': true,
            'modal-container-big': __props.modalSize === 'big',
            'modal-container-medium': __props.modalSize === 'medium'  
          } )
      }, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            _createTextVNode(" default header ")
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "body", {}, () => [
            _createTextVNode(" default body ")
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "footer", {}, () => [
            _createElementVNode("button", {
              class: "modal-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, " Close ")
          ])
        ])
      ], 2)
    ])
  ]))
}
}

})